<template>
  <div class="mt-4 wrap-detail shadow bg-white rounded" v-bind:class="{'toggle': toggle}">
    <div class="toggle-button" v-on:click="toggleView()">
      <font-awesome-icon icon="chevron-circle-up" class="toggle-icon" v-if="!toggle"/>
      <font-awesome-icon icon="chevron-circle-down" class="toggle-icon" v-if="toggle"/>
    </div>
    <b-tabs align="center" nav-wrapper-class="animated fadeInDown">
      <!-- PROPERTIES-TAB (Información)-->
      <b-tab title="Información">
        <PropertiesView class="animated fadeIn"/>
      </b-tab>
      <!-- PERMISSIONS-TAB -->
      <b-tab title="Permisos" >
        <PermissionsView class="animated fadeIn"/>
      </b-tab>
      <!-- SUBSCRIPTIONS-TAB -->
      <b-tab title="Suscripciones">
        <SubscriptionsView class="animated fadeIn"/>
      </b-tab>
      <!-- COMMENTS-TAB -->
      <b-tab title="Comentarios">
        <CommentsView class="animated fadeIn"/>
      </b-tab>
      <!-- BINNACLE-TAB -->
      <b-tab title="Bitácora">
        <BinnacleView class="animated fadeIn"/>
      </b-tab>
      <!-- EXPEDIENT-TAB -->
      <b-tab v-if="showApprovalExpedientView" title="Aprobaciones">
        <ApprovalExpedientView class="animated fadeIn"/>
      </b-tab>
      <b-tab v-if="haveFileCreated" title="Expedientes">
        <FileExpedientView class="animated fadeIn" :file="fileCreated"/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronCircleDown, faChevronCircleUp, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import PropertiesView from '@/febos/global/documentManagement/vistas/PropertiesView';
import CommentsView from '@/febos/global/documentManagement/vistas/CommentsView';
import BinnacleView from '@/febos/global/documentManagement/vistas/BinnacleView';
import SubscriptionsView from '@/febos/global/documentManagement/vistas/SubscriptionsView';
import PermissionsView from '@/febos/global/documentManagement/vistas/PermissionsView';
import ApprovalExpedientView from '@/febos/global/documentManagement/vistas/ApprovalExpedientView';
import FileExpedientView from '@/febos/global/documentManagement/vistas/FileExpedientView';
import { ioExpedientesSearch } from '@/febos/servicios/api/busqueda.api';

library.add(faChevronCircleDown, faChevronCircleUp, faInfoCircle);

export default {
  name: 'details-panel',
  components: {
    PropertiesView,
    CommentsView,
    SubscriptionsView,
    PermissionsView,
    BinnacleView,
    ApprovalExpedientView,
    FileExpedientView
  },
  props: {
    detailItem: Object
  },
  data() {
    return {
      haveFileCreated: false,
      fileCreated: {},
      toggle: false
    };
  },
  watch: {
    async getSelectedElement() {
      try {
        const id = this.getSelectedElement.documentId || this.getSelectedElement.id;
        const query = {
          params: {
            tipo: 'EXP',
            campos: '*',
            pagina: 1,
            orden: '-fechaCreacion',
            elementosPorPagina: 10,
            filtros: `febosId:${id}`
          }
        };
        const { data } = await ioExpedientesSearch(query);
        if (data.documentos.length) {
          [this.fileCreated] = data.documentos;
          this.haveFileCreated = true;
        } else {
          this.haveFileCreated = false;
        }
      } catch (e) {
        console.log('e', e);
      }
    }
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getSelectedRepositoryId',
      'getSelectedFolderId',
      'getSelectedElement',
      'getTreeElements',
      'getRepositories'
    ]),
    showApprovalExpedientView() {
      return this.getSelectedElement.type === 'file'
              && this.getSelectedElement.approvalState
              && this.getSelectedElement.approvalState > 0;
    },
    showFileExpedientView() {
      return true; // TODO: VALIDAR QUE HAYAN EXPEDIENTES CREADOS DEL ARCHIVO
    }
  },
  methods: {
    async searchFile() {
      const id = this.getSelectedElement.documentId || this.getSelectedElement.id;
      try {
        const query = {
          params: {
            tipo: 'EXP',
            campos: '*',
            pagina: 1,
            orden: '-fechaCreacion',
            elementosPorPagina: 10,
            filtros: `febosId:${id}`
          }
        };
        const { data } = await ioExpedientesSearch(query);
        if (data.documentos.length) {
          [this.fileCreated] = data.documentos;
          this.haveFileCreated = true;
        } else {
          this.haveFileCreated = false;
        }
      } catch (e) {
        console.log('e', e);
      }
    },
    toggleView() {
      this.toggle = !this.toggle;
      this.$emit('toggleRepositoryViewPanel');
    },
  },
  created() {
    this.searchFile();
  }
};
</script>

<style lang="scss" scoped>
.wrap-detail {
  height: 30vh;
  overflow: scroll;
}
.toggle-button{
  position: absolute;
  font-size: 20px;
  right: 15px;
  cursor: pointer;
  z-index: 9;
  color:rgb(var(--vs-primary));
}
.toggle{
  height:calc(var(--vh, 1vh) * 100 - 34rem)!important;
}
</style>
